import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DeclineReason = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.primaryText};
  cursor: pointer;
  font-size: 12px;
  text-align: center;
  padding: 5px 0;
  margin: 5px 0;
`;

const ChatDecline = ({ reason, handleClickOnReason }) => (
  <DeclineReason onClick={() => handleClickOnReason(reason)}>
    {reason}
  </DeclineReason>
);

ChatDecline.propTypes = {
  reason: PropTypes.string.isRequired,
  handleClickOnReason: PropTypes.func.isRequired,
};

export default ChatDecline;
